import moment from "moment";

export function getFormattedDate(inputDate:string,format:string):string{
   return moment.utc(inputDate).format(format);
}

export function getFormattedTime(inputDate:string):string{
    return new Date(inputDate).toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
 }

